<template>
  <ion-page>
    <master-layout :pageTitle="category?category.title:''">
      <Loading v-if="loading"></Loading>
      <div v-if="!loading">
        <div v-if="!error">

          <div v-if="(category && category.siblings.length)" class="service-top-menu">
            <div v-for="item in category.siblings"
                 :class="'service-top-menu-item '+(item._id===category._id?'active':'')" :key="item._id">
              <router-link :to="(item.app_url?item.app_url:'')">{{ item.title }}</router-link>
            </div>
          </div>

          <ion-grid>
            <ion-row>
              <ion-col size="6">
                <button class="btn btn-info btn-block" @click="showFilterModal=true">
                  <i class="fal fa-filter"></i> جستجو پیشرفته
                </button>
              </ion-col>
              <ion-col size="6">
                <button class="btn btn-info btn-block" @click="showSortModal=true">
                  <i class="fal fa-list-alt"></i> <span style="font-size: 11px"> به ترتیب {{ sortTitle }}</span>
                </button>
              </ion-col>
            </ion-row>
          </ion-grid>

          <div id="product_items" v-if="products && products.length">
            <div v-for="(item,index) in products" :key="item._id">

              <div v-if="item.type ==='simple'" :class="'card '+item.type+(index===0?'first':'')"
                   data-animation="zoomIn">
                <router-link :to="'/ShopProduct/'+item._id">
                  <div class="overlay-link"></div>
                </router-link>
                <div class="search-product-item">
                  <div class="special_info">
                    <div v-if="item.default_provider && item.default_provider.special_price">
                      <div class="special-price">
                        <div v-if="item.default_provider.special_end_time">
                          <div class="float-right">
                            پیشنهاد شگفت انگیز
                          </div>
                          <div class="float-left">
                            <div class="dc-timer" data-time="{{item.default_provider.special_end_time}}">
                              <h6 class="text-danger timer">
                              </h6>
                            </div>
                          </div>
                        </div>
                        <div v-else>
                          <div class="float-right">
                            پیشنهاد ویژه
                          </div>
                        </div>
                        <div class="clearfix"></div>
                      </div>
                    </div>
                  </div>
                  <div class="info_item">
                    <div class="service-product-thumbnail">
                      <img class="img-fluid" :src="item.thumbnail" :alt="item.title">
                    </div>
                    <div class="service-product-info">
                      <h3>{{ item.title }}</h3>
                      <div class="price-info">

                        <div v-if="item.rate" class="point" data-vote_number="از {{item.rate_people}} رای">
                          <span> {{ item.rate }} / 5</span>
                        </div>

                        <div v-if="item.default_provider && item.default_provider.special_price != null">
                          <div class="real-price">
                            <del>{{ item.default_provider.original_price }}</del>
                          </div>
                          <span class="discount-percent">{{ item.default_provider.special_price_percent }}%</span>
                          <div class="price">
                            <Money :number="item.default_provider.special_price"></Money>
                            <span>تومان</span>
                          </div>

                        </div>
                        <div v-else class="price">
                          <Money :number="(item.default_provider?item.default_provider.price:'')"></Money>
                          <span>تومان</span>
                        </div>

                      </div>

                      <div v-if="item.rate" class="point" :data-vote_number="'از '+item.rate_people+' رای'">
                        <span> {{ item.rate }} / 5</span>
                      </div>

                      <div class="provider_name">
                      <span v-if="item.default_provider && item.default_provider.title">
                      فروشنده : {{ item.default_provider.title }}
                      </span>
                      </div>

                    </div>
                  </div>

                  <div class="clearfix"></div>

                </div>

              </div>

              <div v-else class="card" data-animation="zoomIn">
                <router-link :to="'/ShopProduct/'+item._id">
                  <div class="overlay-link"></div>
                </router-link>
                <div class="search-product-item">
                  <div class="special_info">
                    <div
                        v-if="(item.default_provider && item.default_provider.provider && item.default_provider.provider.special_price)"
                        class="special-price">
                      <div v-if="item.default_provider.provider.special_end_time">
                        <div class="float-right">
                          پیشنهاد شگفت انگیز
                        </div>
                        <div class="float-left">
                          <div class="dc-timer" :data-time="item.default_provider.provider.special_end_time">
                            <h6 class="text-danger timer">
                            </h6>
                          </div>
                        </div>
                      </div>
                      <div v-else>
                        <div class="float-right">
                          پیشنهاد ویژه
                        </div>
                      </div>
                      <div class="clearfix"></div>
                    </div>
                  </div>
                  <div class="info_item">
                    <div class="service-product-thumbnail">
                      <img class="img-fluid" :src="item.default_provider.thumbnail" :alt="item.title">
                    </div>
                    <div class="service-product-info">
                      <h3>{{ item.title }}</h3>
                      <div class="price-info">
                        <div
                            v-if="item.default_provider && item.default_provider.provider && item.default_provider.provider.special_price != null">
                          <div class="real-price">
                            <del>{{ item.default_provider.provider.original_price }}</del>
                          </div>
                          <span
                              class="discount-percent">{{
                              item.default_provider.provider.special_price_percent
                            }}%</span>
                          <div class="price">
                            <Money
                                :number="item.default_provider && item.default_provider.provider && item.default_provider.provider.special_price?(item.default_provider.provider.special_price):''"></Money>
                            <span>تومان</span>
                          </div>
                        </div>
                        <div
                            v-else-if="item.default_provider.provider && item.default_provider && item.default_provider.provider.price">
                          <div class="price">
                            <Money :number="item.default_provider.provider.price"></Money>
                            <span>تومان</span>
                          </div>

                        </div>

                      </div>

                      <div v-if="item.rate" class="point" :data-vote_number="'از '+item.rate_people+' رای'">
                        <span> {{ item.rate }} / 5</span>
                      </div>

                      <div
                          v-if="item.default_provider && item.default_provider.provider && item.default_provider.provider.title"
                          class="provider_name">
                        فروشنده : {{ item.default_provider.provider.title }}
                      </div>

                    </div>
                  </div>

                  <div class="clearfix"></div>
                  <div v-if="item.providers.length <= 3" class="attr-values" data-toggle="buttons">
                    <label v-for="(i,index2) in item.providers" :key="index2"
                           :class="'var-select-btn '+(item.default_provider.attr_hash === i.attr_hash?'active':'')">
                      <input @change="changePriceProductPageRadio(index,index2)" class="attr_radio"
                             :checked="item.default_provider.attr_hash === i.attr_hash" type="radio"
                             name="attr" :value="index2" autocomplete="off"> {{ i.attr_str }}
                    </label>
                  </div>

                  <select v-else autocomplete="off"
                          class="selectpicker form-control form-control-sm product_page_select"
                          @change="changeProductAttrSelect($event,index)">
                    <option :value="index2" v-for="(i,index2) in item.providers" :key="index2"
                            :selected="item.default_provider.attr_hash === i.attr_hash"
                    >{{ i.attr_str }}
                    </option>
                  </select>

                </div>

              </div>
            </div>
            <div v-if="!products || !products.length" class="alert alert-warning">جستجو برای این ترکیب از فیلترها با هیچ
              کالایی هم‌خوانی ندارد.
            </div>

            <div v-if="totalPages" class="ion-padding">
              <div class="horizontal-scroll">
                <ul class="pagination pagination-circle pg-blue mb-0">
                  <li v-for="index in totalPages" :key="index" :class="'page-item '+(page===index?'active':'')">
                    <router-link :to="'/ShopSearch/'+index" class="page-link">{{ index }}</router-link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div v-else class="ion-padding">
            <div class="alert alert-warning w-100">جستجو برای این ترکیب از فیلترها با هیچ کالایی هم‌خوانی ندارد.
            </div>
            <div class="d-block">تلاش کنید:</div>
            <ul>
              <li>تعدادی از فیلترها را حذف کنید.</li>
              <li>در جستجو از عبارت‌های متداول‌تر استفاده کنید.</li>
            </ul>
          </div>
        </div>
        <div v-if="error" class="ion-padding">
          <br/>
          <div class="alert alert-danger">{{ error }}</div>
        </div>
      </div>


      <div style="--animate-duration:0.5s" :class="'modal animated fadeInUp '+(showSortModal?'show':'')">
        <div class="modal-header">
          <h2>مرتب سازی براساس</h2>
          <span class="close-btn" @click="showSortModal=false"><i class="fal fa-window-close"></i></span>
        </div>
        <div class="modal-content">
          <div class="top-sort-list">
            <ul class="m-0 p-0 pr-2">
              <li @click="sortTitle='نام'; orderBy='name'; orderType='asc'; doSearch(); showSortModal=false;"
                  data-name="name" data-order="asc" class="is-active active">
                <div class="form-check">
                  <label class="form-check-label">
                    <input type="radio" class="form-check-input" name="optradio">
                    <span class="pr-3 title">نام</span>
                  </label>
                </div>
              </li>
              <li @click="sortTitle='پربازدیدترین'; orderBy='view'; orderType='desc'; doSearch(); showSortModal=false;"
                  data-name="view" data-order="desc">
                <div class="form-check">
                  <label class="form-check-label">
                    <input type="radio" class="form-check-input" name="optradio">
                    <span class="pr-3 title">پربازدیدترین</span>
                  </label>
                </div>
              </li>
              <li @click="sortTitle='پرفروش ترین'; orderBy='sell'; orderType='desc'; doSearch(); showSortModal=false;"
                  data-name="sell" data-order="desc">
                <div class="form-check">
                  <label class="form-check-label">
                    <input type="radio" class="form-check-input" name="optradio">
                    <span class="pr-3 title">پرفروش ترین</span>
                  </label>
                </div>
              </li>
              <li @click="sortTitle='محبوب ترین'; orderBy='rate'; orderType='desc'; doSearch(); showSortModal=false;"
                  data-name="rate" data-order="desc">
                <div class="form-check">
                  <label class="form-check-label">
                    <input type="radio" class="form-check-input" name="optradio">
                    <span class="pr-3 title">محبوب ترین</span>
                  </label>
                </div>
              </li>
              <li @click="sortTitle='جدیدترین'; orderBy='date'; orderType='desc'; doSearch(); showSortModal=false;"
                  data-name="date" data-order="asc">
                <div class="form-check">
                  <label class="form-check-label">
                    <input type="radio" class="form-check-input" name="optradio">
                    <span class="pr-3 title">جدیدترین</span>
                  </label>
                </div>
              </li>
              <li @click="sortTitle='ارزانترین'; orderBy='price'; orderType='asc'; doSearch(); showSortModal=false;"
                  data-name="price" data-order="asc">
                <div class="form-check">
                  <label class="form-check-label">
                    <input type="radio" class="form-check-input" name="optradio">
                    <span class="pr-3 title">ارزانترین</span>
                  </label>
                </div>
              </li>
              <li @click="sortTitle='گرانترین'; orderBy='price'; orderType='desc'; doSearch(); showSortModal=false;"
                  data-name="price" data-order="desc">
                <div class="form-check">
                  <label class="form-check-label">
                    <input type="radio" class="form-check-input" name="optradio">
                    <span class="pr-3 title">گرانترین</span>
                  </label>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>


      <div style="--animate-duration:0.5s" :class="'modal animated fadeInUp '+(showFilterModal?'show':'')">
        <div class="modal-header">
          <h2>جستجو پیشرفته
            <small>مجموع نتایج:
              <Money ref="totalRecordElement" :number="totalRecords"/>
            </small></h2>
          <span class="close-btn" @click="showFilterModal=false"><i class="fal fa-window-close"></i></span>
        </div>
        <div class="modal-content">
          <div class="card" style="padding: 8px 12px">
            <h6 style="margin-top: 0">جستجو با کد فنی</h6>
            <AjaxInput route="product/suggestTechCode" placeholder="جستجو با کد فنی محصولات ..." @input="setTechCode"/>
          </div>

          <div class="card" style="padding: 8px 12px">
            <h6 style="margin-top: 0">مدل و تیپ خودرو</h6>
            <ali-ajax-select :on-change="setCarTypeFilter" route="app/GetTypeForSelect" title="تیپ خودرو"
                             itemTitle="title" name="type_id" desc="جستجو تیپ خودرو" itemId="_id"></ali-ajax-select>
          </div>
          <div v-if="brandFilters && brandFilters.length" class="card filter-items">
            <!--product-brands-header-->
            <div class="toggle-header product-brands-header">
              <h6>برند</h6>
            </div>
            <div class="toggle-div product-brands-div">
              <div class="icon-input product-search-page">
                <input class="form-control search-input" placeholder="...جستجوی نام برند">
                <i class="fal fa-search"></i>
              </div>
              <div class="mt-1 search-items">
                <ul>
                  <li v-for="brand in brandFilters" :key="brand.id">
                    <label :for="'brand-'+brand.id" class="li-search-filter ">{{ brand.title }}</label>
                    <span class="en_title">{{ brand.english_title }}</span>
                    <label class="li-checkbox">
                      <label class="checkbox-container">
                        <input :checked="!!brand.is_checked" @click="brand.is_checked = !brand.is_checked; doSearch()"
                               type="checkbox" :value="brand.id" class="brands" name="brands[]" :id="'brand-'+brand.id">
                        <span class="checkmark"></span>
                      </label>
                    </label>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div v-if="priceFilter && priceFilter.max" class="card filter-items">
            <div class="toggle-header product-brands-header">
              <h6>قیمت</h6>
            </div>
            <div class="toggle-div">
              <ion-range :min="priceFilter.min?priceFilter.min:0" :max="priceFilter.max" mode="ios" step="10" pin="true"
                         dualKnobs="true" debounce="700" v-model="priceFilterValue" snaps="true" ticks="false"
                         color="secondary">
                <ion-label slot="start">
                  <Money :number="priceFilter.min?priceFilter.min:0"></Money>
                </ion-label>
                <ion-label slot="end">
                  <Money :number="priceFilter.max"></Money>
                </ion-label>
              </ion-range>
              <div v-if="priceFilterValue">
                از <strong><Money ref="priceFilterElement" v-model="priceFilterValue.lower" :number="priceFilterValue.lower" /></strong> تا <strong><Money ref="priceFilterElement" v-model="priceFilterValue.upper" :number="priceFilterValue.upper"/></strong>
              </div>
            </div>
          </div>

          <div v-if="attributes && attributes.length">
            <div v-for="(attr,index) in attributes" :key="index" class="card filter-items">
              <!--product-brands-header-->
              <div class="toggle-header product-brands-header">
                <h6>{{ attr.title }}</h6>
              </div>
              <div class="toggle-div product-brands-div">
                <div class="icon-input product-search-page">
                  <input class="form-control search-input" placeholder="...جستجو">
                  <i class="fal fa-search"></i>
                </div>
                <div class="mt-1 search-items">
                  <ul>
                    <li v-for="(item,index2) in attr.values" :key="index2">
                      <label :for="'item-'+item.item_id" class="li-search-filter ">{{ item.title }}</label>
                      <label class="li-checkbox">
                        <label class="checkbox-container">
                          <input @click="addToAttrs(index,index2)"
                                 :checked="item.isChecked"
                                 type="checkbox" :value="item.item_id" class="brands" name="brands[]"
                                 :id="'item-'+item.item_id">
                          <span class="checkmark"></span>
                        </label>
                      </label>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <br/>
          <br/>
          <br/>
        </div>
      </div>
    </master-layout>
  </ion-page>
</template>

<script>
import {IonPage, useBackButton, IonGrid, IonRow, IonCol, IonRange, IonLabel} from '@ionic/vue'
import {mapActions} from "vuex";
import Money from "@/components/Money";
import Loading from "@/components/Loading";
import AjaxInput from "@/components/AjaxInput";
import AliAjaxSelect from "@/components/aliAjaxSelect";

export default {
  name: "types",
  data: function ()
  {
    return {
      beginPrice: null,
      endPrice: null,
      techCode: '',
      products: [],
      page: 1,
      showFilterModal: false,
      showSortModal: false,
      sortTitle: 'نام',
      orderBy: 'name',
      orderType: 'asc',
      totalPages: 0,
      totalRecords: 0,
      loading: true,
      error: null,
      catId: null,
      category: null,
      filters: {},
      attributes: [],
      country: [],
      priceFilter: null,
      priceFilterValue: null,
      dontUsePrice: false,
      endAttr: [],
      carTypeId: null,
      brandFilters: []
    }
  },
  mounted()
  {
    this.init();
    this.getCategoryFilters(this.catId).then((data) =>
    {
      if (data && data.filters)
      {
        this.brandFilters = data.filters.brands;
        this.attributes = data.filters.attributes;
        this.country = data.filters.country;
        this.priceFilter = data.filters.price;
        if (this.priceFilter && this.priceFilter.max)
        {
          this.priceFilterValue = {
            lower: this.priceFilter.min ? this.priceFilter.min : 0,
            upper: this.priceFilter.max
          }
        }
      }
    })
    useBackButton(10, async (processNextHandler) =>
    {
      if (this.showFilterModal || this.showSortModal)
      {
        this.showFilterModal = false;
        this.showSortModal = false;
      }
      else
        processNextHandler();
    });
  },
  methods: {
    setTechCode(code)
    {
      if (code !== this.techCode)
      {
        this.techCode = code;
        this.doSearch();
      }
    },
    doSearch()
    {
      const data = {categories: this.catId, page: this.page, orderType: this.orderType, orderBy: this.orderBy};

      if (this.beginPrice != null)
      {
        data.begin_price = this.beginPrice;
      }
      if (this.endPrice != null)
      {
        data.end_price = this.endPrice;
      }

      let brands = [];
      if (this.brandFilters)
      {
        for (let i = 0; i < this.brandFilters.length; i++)
        {
          if (this.brandFilters[i].is_checked)
            brands.push(this.brandFilters[i].id);
        }
        if (brands.length)
          data.brands = brands;
      }

      const attributes = [];

      const endAttr = this.endAttr;
      if (endAttr)
      {
        for (let i = 0; i < endAttr.length; i++)
        {
          if (attributes.indexOf(endAttr[i].parent) === -1)
            attributes.push(endAttr[i].parent);
          let str = endAttr[i].parent + '_items';
          data[str] = endAttr[i].item_id;
        }
      }
      data.attributes = attributes;

      if (this.techCode && this.techCode.length)
        data.tech_code = [this.techCode];

      if (this.carTypeId)
        data.car_type_id = this.carTypeId;


      this.search(data).then((result) =>
      {
        if (result.ok)
        {
          this.products = result.products;
          this.totalPages = result.totalPages;
          this.totalRecords = result.totalRecords;
          this.$refs.totalRecordElement.set(this.totalRecords)
        }
        else
          this.error = result.error;
      })
    },
    addToAttrs(index, index2)
    {
      let endAttr = this.endAttr;
      const attribute = this.attributes[index];
      const value = attribute.values[index2];
      let isChecked = value.isChecked;
      if (isChecked)
      {
        value.isChecked = false;
        const index = endAttr.findIndex(function (o)
        {
          return o.item_id === value.item_id;
        })
        if (index !== -1) endAttr.splice(index, 1);
      }
      else
      {
        value.isChecked = true;
        endAttr.push(value)
      }
      this.doSearch();
    },
    init()
    {
      this.catId = this.$route.params.catId;
      const page = Number(this.$route.params.page);
      if (page && !isNaN(page) && page > 0)
        this.page = page;

      this.getCategory(this.catId).then((result) =>
      {
        this.loading = false;
        if (result)
        {
          if (result.ok)
          {
            this.category = result.category;
            this.doSearch()
          }
          else
            this.error = result.error;
        }
        else
          this.error = 'لطفا از دسترسی تلفن همراه خود به اینترنت مطمئن شوید'
      })
    },

    goToPartsPage()
    {
      this.$router.push({
        path: '/cars/parts/' + this.carType._id, params: {
          otherProp:
              {
                test: 'ok'
              }
        }
      })
    },
    changeProductAttrSelect(event, index)
    {
      const value = event.target.value;
      const product = this.products[index];
      product.default_provider = product.providers[value];
    },
    changePriceProductPageRadio(index, index2)
    {
      const product = this.products[index];
      product.default_provider = product.providers[index2];
    },
    setCarTypeFilter(c)
    {
      if (c && c[0])
      {
        this.carTypeId = c[0]._id;
      }
      else
        this.carTypeId = null;

      this.doSearch();
    },
    ...mapActions("shop", {
      getCategory: 'getCategory',
      getCategoryFilters: 'getCategoryFilters',
      /**
       * @typedef searchProduct
       */
      search: 'searchProduct'
    }),
    activateTab(tab)
    {
      if (this[tab])
        return;

      this.generalTab = false;
      this.attrTab = false;
      this.technicalTab = false;
      this[tab] = true;
    },
  },
  watch: {
    priceFilterValue()
    {
      this.beginPrice = this.priceFilterValue.lower;
      this.endPrice = this.priceFilterValue.upper;
      this.doSearch();
    },
    showFilterModal()
    {
      window.$('#main-container').toggleClass('modal-is-open');
    },
    '$route.path': {
      handler(newUrl)
      {
        if (newUrl.indexOf('ShopCategory') >= 0 || newUrl.indexOf('shopCategory') >= 0)
        {
          this.loading = true;
          this.init()
        }
      }
    }
  },
  components: {
    AjaxInput, AliAjaxSelect,
    Loading,
    Money,
    IonGrid, IonRow, IonCol, IonRange, IonLabel,
    IonPage
  }
}

</script>


<style scoped>
.overlay-link {
  position: absolute;
  top: 0;
  right: 0;
  height: 100%;
  display: block;
  width: 100%;
  z-index: 1;
}

.card {
  position: relative;
}

.search-input-area {
  padding: 10px 15px 40px;
  background: #00295e;
}

small {
  position: absolute;
  right: 11px;
  top: 12px;
  color: #313131;
  font-weight: lighter;
}

.result-area .table-responsive {
  max-height: 350px;
  overflow-y: auto;
}

.thumbnail img {
  width: 125px;
  height: 125px;
}

.title h4 {
  font-size: 16px;
  height: 45px;
}

.tab-menu {
  position: sticky;
  top: 0;
  box-shadow: 0 4px 9px 0 rgba(0, 0, 0, 0.2);
}

.tab-menu li {
  width: 33%;
}

.brand-img {
  text-align: center;
}

.brand-img img {
  height: 80px;
  max-width: 100%;
  width: auto;
}

.p-content, .p-content * {
  font-size: 18px !important;
  line-height: 30px;
  color: #1f1f1f;
}

h2 {
  font-size: 16px;
  font-weight: bold;
  text-align: center;
}

h4 {
  font-size: 18px;
  margin-bottom: -10px;
  margin-top: 25px;
}

.table th {
  font-size: 14px;
}

.table td {
  font-size: 16px;
}

.card.variable {
  position: relative;
}

.service-product-info h3 {
  font-size: 14px;
}

.service-product-thumbnail img {
  max-height: 110px;
}

.card {
  background: #fff;
}

.provider_name {
  font-size: 11px;
  color: #000050;
  font-weight: bold;
  margin-top: 5px;
}

.price-info {
  color: #00aa8d;
}
</style>